export default "__VITE_ASSET__C8NjD$1r__"